<script setup lang="ts">
import { ref } from 'vue';
import AddressManager from 'components/User/Addresses/AddressManager.vue';

defineProps<{
  modelValue: boolean;
}>();

const $emit = defineEmits(['update:model-value', 'change']);

const selectedAddress = (addressId: number) => {
  $emit('change', addressId);
};
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:model-value', $event)">
    <q-card>
      <q-card-section class="flex no-wrap justify-between items-center">
        <div class="q-px-sm">
          <div class="text-h6 text-weight-bold">Adres Yönetimi</div>
          <div class="text-subtitle2">Adreslerinizi yönetin, yeni adres ekleyin veya mevcut adresleri düzenleyin.</div>
        </div>
        <div>
          <q-btn icon="close" round flat size=".8rem" class="q-ml-auto" @click="$emit('update:model-value', false)" />
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section>
        <address-manager ref="addressManagerRef" selection @select="selectedAddress" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped></style>
